import { useDispatch, useSelector } from "react-redux";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomTextInput from "../../../../components/CustomTextInput";
import { CompanyService } from "../../../../services/CompanyService";
import { ConstantService } from "../../../../services/ConstantService";
import { storeActivityIndicator, storeFastFirm } from "../../../../redux/reducers/authSlice";
import { GetCompanyByIdResponse } from "../../../../models/response/company/GetCompanyByIdResponse";
import toast from "react-hot-toast";
import { ProjectRegionService } from "../../../../services/ProjectRegionService";
import { GetProjectRegionListResponse } from "../../../../models/response/projectRegion/GetProjectRegionListResponse";
import { MeetingCompanyTypeEnum, ProjectEnum } from "../../../../models/common/Enums";
import { RootState } from "../../../../redux/store";

interface Props {
    firmInformationRef: any
    selectedSenderCustomer: CustomSingleSelectModel | undefined
    setSelectedSenderCustomer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedSenderCustomerAddressType: CustomSingleSelectModel | undefined
    setSelectedSenderCustomerAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    senderCustomerAddressText: string | undefined
    setSenderCustomerAddressText: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedReceiverCustomer: CustomSingleSelectModel | undefined
    setSelectedReceiverCustomer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedReceiverCustomerAddressType: CustomSingleSelectModel | undefined
    setSelectedReceiverCustomerAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    receiverCustomerAddressText: string | undefined
    setReceiverCustomerAddressText: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedLoadingFirmCustomer: CustomSingleSelectModel | undefined
    setSelectedLoadingFirmCustomer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedLoadingFirmCustomerAddressType: CustomSingleSelectModel | undefined
    setSelectedLoadingFirmCustomerAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    loadingFirmCustomerAddressText: string | undefined
    setLoadingFirmCustomerAddressText: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedDeliverFirmCustomer: CustomSingleSelectModel | undefined
    setSelectedDeliverFirmCustomer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeliverFirmCustomerAddressType: CustomSingleSelectModel | undefined
    setSelectedDeliverFirmCustomerAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    deliverFirmCustomerAddressText: string | undefined
    setDeliverFirmCustomerAddressText: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedLoadingCounty: CustomSingleSelectModel | undefined
    setSelectedLoadingCounty: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedLoadingDistrict: CustomSingleSelectModel | undefined
    setSelectedLoadingDistrict: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedLoadingNeighborhood: CustomSingleSelectModel | undefined
    setSelectedLoadingNeighborhood: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeliverCounty: CustomSingleSelectModel | undefined
    setSelectedDeliverCounty: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeliverDistrict: CustomSingleSelectModel | undefined
    setSelectedDeliverDistrict: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeliverNeighborhood: CustomSingleSelectModel | undefined
    setSelectedDeliverNeighborhood: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedLoadingRegion: CustomSingleSelectModel | undefined
    setSelectedLoadingRegion: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeliverRegion: CustomSingleSelectModel | undefined
    setSelectedDeliverRegion: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedCarryType: CustomSingleSelectModel | undefined
}

const FirmInformation = ({
    firmInformationRef,
    selectedSenderCustomer,
    selectedSenderCustomerAddressType,
    senderCustomerAddressText,
    setSelectedSenderCustomer,
    setSelectedSenderCustomerAddressType,
    setSenderCustomerAddressText,
    receiverCustomerAddressText,
    selectedReceiverCustomer,
    selectedReceiverCustomerAddressType,
    setReceiverCustomerAddressText,
    setSelectedReceiverCustomer,
    setSelectedReceiverCustomerAddressType,
    loadingFirmCustomerAddressText,
    selectedLoadingFirmCustomer,
    selectedLoadingFirmCustomerAddressType,
    setLoadingFirmCustomerAddressText,
    setSelectedLoadingFirmCustomer,
    setSelectedLoadingFirmCustomerAddressType,
    deliverFirmCustomerAddressText,
    selectedDeliverFirmCustomer,
    selectedDeliverFirmCustomerAddressType,
    setDeliverFirmCustomerAddressText,
    setSelectedDeliverFirmCustomer,
    setSelectedDeliverFirmCustomerAddressType,
    selectedLoadingCounty,
    selectedLoadingDistrict,
    selectedLoadingNeighborhood,
    setSelectedLoadingCounty,
    setSelectedLoadingDistrict,
    setSelectedLoadingNeighborhood,
    selectedDeliverCounty,
    selectedDeliverDistrict,
    selectedDeliverNeighborhood,
    setSelectedDeliverCounty,
    setSelectedDeliverDistrict,
    setSelectedDeliverNeighborhood,
    selectedDeliverRegion,
    selectedLoadingRegion,
    setSelectedDeliverRegion,
    setSelectedLoadingRegion,
    selectedCarryType
}: Props) => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)

    const onSenderCustomerChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        setSelectedSenderCustomer(selectedValue);
        setSelectedSenderCustomerAddressType(undefined);
        setSenderCustomerAddressText('');

        if (!selectedValue) {
            onLoadingFirmCustomerChange(undefined);
            return;
        }

        try {
            dispatch(storeActivityIndicator(true))

            var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(selectedValue.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data.companyAddresses.length > 0) {
                var firstAddress = response.data.companyAddresses.find(x => x.isDefault);

                if (!firstAddress)
                    firstAddress = response.data.companyAddresses[0];

                if (firstAddress.addressTypeId && firstAddress.addressTypeName) {
                    setSelectedSenderCustomerAddressType({ label: firstAddress.addressTypeName, value: firstAddress.addressTypeId });
                    setSenderCustomerAddressText(firstAddress.addressText);
                }
            }

        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }

        onLoadingFirmCustomerChange(selectedValue);
    }

    const onSenderCustomAddressTypeChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        setSelectedSenderCustomerAddressType(selectedValue);

        if (!selectedValue || !selectedSenderCustomer) {
            setSenderCustomerAddressText('');
            return;
        }

        try {
            dispatch(storeActivityIndicator(true))

            var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(selectedSenderCustomer.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            var firstAddress = response.data.companyAddresses.find(x => x.addressTypeId == selectedValue.value);

            if (firstAddress && firstAddress.addressTypeId && firstAddress.addressTypeName) {
                setSelectedSenderCustomerAddressType({ label: firstAddress.addressTypeName, value: firstAddress.addressTypeId });
                setSenderCustomerAddressText(firstAddress.addressText);
            }
            else {
                setSenderCustomerAddressText('');
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const onReceiverCustomerChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        setSelectedReceiverCustomer(selectedValue);
        setSelectedReceiverCustomerAddressType(undefined);
        setReceiverCustomerAddressText('');

        if (!selectedValue) {
            onDeliverFirmCustomerChange(undefined);
            return;
        }

        try {
            dispatch(storeActivityIndicator(true))

            var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(selectedValue.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data.companyAddresses.length > 0) {
                var firstAddress = response.data.companyAddresses.find(x => x.isDefault);

                if (!firstAddress)
                    firstAddress = response.data.companyAddresses[0];

                if (firstAddress.addressTypeId && firstAddress.addressTypeName) {
                    setSelectedReceiverCustomerAddressType({ label: firstAddress.addressTypeName, value: firstAddress.addressTypeId });
                    setReceiverCustomerAddressText(firstAddress.addressText);
                }
            }

        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }

        onDeliverFirmCustomerChange(selectedValue);
    }

    const onReceiverCustomAddressTypeChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        setSelectedReceiverCustomerAddressType(selectedValue);

        if (!selectedValue || !selectedReceiverCustomer) {
            setReceiverCustomerAddressText('');
            return;
        }

        try {
            dispatch(storeActivityIndicator(true))

            var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(selectedReceiverCustomer.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            var firstAddress = response.data.companyAddresses.find(x => x.addressTypeId == selectedValue.value);

            if (firstAddress && firstAddress.addressTypeId && firstAddress.addressTypeName) {
                setSelectedReceiverCustomerAddressType({ label: firstAddress.addressTypeName, value: firstAddress.addressTypeId });
                setReceiverCustomerAddressText(firstAddress.addressText);
            }
            else {
                setReceiverCustomerAddressText('');
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const onLoadingFirmCustomerChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        setSelectedLoadingFirmCustomer(selectedValue);
        setSelectedLoadingFirmCustomerAddressType(undefined);
        setLoadingFirmCustomerAddressText('');
        setSelectedLoadingCounty(undefined);
        setSelectedLoadingDistrict(undefined);
        setSelectedLoadingNeighborhood(undefined);
        setSelectedLoadingRegion(undefined);

        if (!selectedValue)
            return;

        try {
            dispatch(storeActivityIndicator(true))

            var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(selectedValue.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data.companyAddresses.length > 0) {
                var firstAddress = response.data.companyAddresses.find(x => x.isDefault);

                if (!firstAddress)
                    firstAddress = response.data.companyAddresses[0];

                if (firstAddress.addressTypeId && firstAddress.addressTypeName) {
                    setSelectedLoadingFirmCustomerAddressType({ label: firstAddress.addressTypeName, value: firstAddress.addressTypeId });
                    setLoadingFirmCustomerAddressText(firstAddress.addressText);

                    var _selectedCounty: CustomSingleSelectModel | undefined = undefined;

                    if (firstAddress.countyId && firstAddress.countyName)
                        _selectedCounty = { label: firstAddress.countyName, value: firstAddress.countyId };

                    setSelectedLoadingCounty(_selectedCounty);

                    var _selectedDistrict: CustomSingleSelectModel | undefined = undefined;

                    if (firstAddress.districtId && firstAddress.districtName)
                        _selectedDistrict = { label: firstAddress.districtName, value: firstAddress.districtId };

                    setSelectedLoadingDistrict(_selectedDistrict);

                    var _selectedNeighborhood: CustomSingleSelectModel | undefined = undefined;

                    if (firstAddress.neighborhoodId && firstAddress.neighborhoodName)
                        _selectedNeighborhood = { label: firstAddress.neighborhoodName, value: firstAddress.neighborhoodId };

                    setSelectedLoadingNeighborhood(_selectedNeighborhood);

                }
            }

        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const onLoadingFirmCustomAddressTypeChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        setSelectedLoadingFirmCustomerAddressType(selectedValue);

        if (!selectedValue || !selectedLoadingFirmCustomer) {
            setLoadingFirmCustomerAddressText('');
            return;
        }

        try {
            dispatch(storeActivityIndicator(true))

            var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(selectedLoadingFirmCustomer.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            var firstAddress = response.data.companyAddresses.find(x => x.addressTypeId == selectedValue.value);

            if (firstAddress && firstAddress.addressTypeId && firstAddress.addressTypeName) {
                setSelectedLoadingFirmCustomerAddressType({ label: firstAddress.addressTypeName, value: firstAddress.addressTypeId });
                setLoadingFirmCustomerAddressText(firstAddress.addressText);

                var _selectedCounty: CustomSingleSelectModel | undefined = undefined;

                if (firstAddress.countyId && firstAddress.countyName)
                    _selectedCounty = { label: firstAddress.countyName, value: firstAddress.countyId };

                setSelectedLoadingCounty(_selectedCounty);

                var _selectedDistrict: CustomSingleSelectModel | undefined = undefined;

                if (firstAddress.districtId && firstAddress.districtName)
                    _selectedDistrict = { label: firstAddress.districtName, value: firstAddress.districtId };

                setSelectedLoadingDistrict(_selectedDistrict);

                var _selectedNeighborhood: CustomSingleSelectModel | undefined = undefined;

                if (firstAddress.neighborhoodId && firstAddress.neighborhoodName)
                    _selectedNeighborhood = { label: firstAddress.neighborhoodName, value: firstAddress.neighborhoodId };

                setSelectedLoadingNeighborhood(_selectedNeighborhood);

            }
            else {
                setLoadingFirmCustomerAddressText('');
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const onDeliverFirmCustomerChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        setSelectedDeliverFirmCustomer(selectedValue);
        setSelectedDeliverFirmCustomerAddressType(undefined);
        setDeliverFirmCustomerAddressText('');
        setSelectedDeliverCounty(undefined);
        setSelectedDeliverDistrict(undefined);
        setSelectedDeliverNeighborhood(undefined);
        setSelectedDeliverRegion(undefined);

        if (!selectedValue)
            return;

        try {
            dispatch(storeActivityIndicator(true))

            var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(selectedValue.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data.companyAddresses.length > 0) {
                var firstAddress = response.data.companyAddresses.find(x => x.isDefault);

                if (!firstAddress)
                    firstAddress = response.data.companyAddresses[0];

                if (firstAddress.addressTypeId && firstAddress.addressTypeName) {
                    setSelectedDeliverFirmCustomerAddressType({ label: firstAddress.addressTypeName, value: firstAddress.addressTypeId });
                    setDeliverFirmCustomerAddressText(firstAddress.addressText);

                    var _selectedCounty: CustomSingleSelectModel | undefined = undefined;

                    if (firstAddress.countyId && firstAddress.countyName)
                        _selectedCounty = { label: firstAddress.countyName, value: firstAddress.countyId };

                    setSelectedDeliverCounty(_selectedCounty);

                    var _selectedDistrict: CustomSingleSelectModel | undefined = undefined;

                    if (firstAddress.districtId && firstAddress.districtName)
                        _selectedDistrict = { label: firstAddress.districtName, value: firstAddress.districtId };

                    setSelectedDeliverDistrict(_selectedDistrict);

                    var _selectedNeighborhood: CustomSingleSelectModel | undefined = undefined;

                    if (firstAddress.neighborhoodId && firstAddress.neighborhoodName)
                        _selectedNeighborhood = { label: firstAddress.neighborhoodName, value: firstAddress.neighborhoodId };

                    setSelectedDeliverNeighborhood(_selectedNeighborhood);

                }
            }

        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const onDeliverFirmCustomAddressTypeChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        setSelectedDeliverFirmCustomerAddressType(selectedValue);

        if (!selectedValue || !selectedDeliverFirmCustomer) {
            setDeliverFirmCustomerAddressText('');
            return;
        }

        try {
            dispatch(storeActivityIndicator(true))

            var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(selectedDeliverFirmCustomer.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            var firstAddress = response.data.companyAddresses.find(x => x.addressTypeId == selectedValue.value);

            if (firstAddress && firstAddress.addressTypeId && firstAddress.addressTypeName) {
                setSelectedDeliverFirmCustomerAddressType({ label: firstAddress.addressTypeName, value: firstAddress.addressTypeId });
                setDeliverFirmCustomerAddressText(firstAddress.addressText);

                var _selectedCounty: CustomSingleSelectModel | undefined = undefined;

                if (firstAddress.countyId && firstAddress.countyName)
                    _selectedCounty = { label: firstAddress.countyName, value: firstAddress.countyId };

                setSelectedDeliverCounty(_selectedCounty);

                var _selectedDistrict: CustomSingleSelectModel | undefined = undefined;

                if (firstAddress.districtId && firstAddress.districtName)
                    _selectedDistrict = { label: firstAddress.districtName, value: firstAddress.districtId };

                setSelectedDeliverDistrict(_selectedDistrict);

                var _selectedNeighborhood: CustomSingleSelectModel | undefined = undefined;

                if (firstAddress.neighborhoodId && firstAddress.neighborhoodName)
                    _selectedNeighborhood = { label: firstAddress.neighborhoodName, value: firstAddress.neighborhoodId };

                setSelectedDeliverNeighborhood(_selectedNeighborhood);

            }
            else {
                setDeliverFirmCustomerAddressText('');
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <div className='containerPart' ref={firmInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Firma Bilgileri</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText='Gönderici Firma'
                                isLabelRequired
                                selectedValue={selectedSenderCustomer}
                                onChange={onSenderCustomerChange}
                                onMenuOpen={[
                                    () => CompanyService.getCompanyList({ isSenderFirm: true, selectedMeetingCompanyType: { label: '', additionalValue1: MeetingCompanyTypeEnum.CALISILAN_MUSTERI } })
                                ]}
                                labelName='name'
                                valueName='companyId'
                                insertable={((auth.user.user?.data.roles.find(x => x == "Hızlı Firma Ekleme") && !selectedSenderCustomer) || (auth.user.user?.data.roles.find(x => x == "Hızlı Firma Güncelleme") && selectedSenderCustomer)) ? {
                                    onClick: () => {
                                        dispatch(storeFastFirm({
                                            companyId: selectedSenderCustomer?.value,
                                            isSenderFirm: true,
                                            onSubmit: async (response) => {
                                                onSenderCustomerChange({ label: response.name, value: response.companyId })
                                            }
                                        }))
                                    }
                                } : undefined}
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Gönderici Firma Adres Türü"
                                isLabelRequired
                                selectedValue={selectedSenderCustomerAddressType}
                                onChange={onSenderCustomAddressTypeChange}
                                onMenuOpen={() => ConstantService.getConstantList('COMPANY_ADDRESS_TYPE')}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput
                                labelText="Gönderici Firma Adres"
                                isLabelRequired
                                value={senderCustomerAddressText}
                                setValue={setSenderCustomerAddressText}
                            />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText='Alıcı Firma'
                                isLabelRequired
                                selectedValue={selectedReceiverCustomer}
                                onChange={onReceiverCustomerChange}
                                onMenuOpen={[
                                    () => CompanyService.getCompanyList({ isReceiverFirm: true, selectedMeetingCompanyType: { label: '', additionalValue1: MeetingCompanyTypeEnum.CALISILAN_MUSTERI } })
                                ]}
                                labelName='name'
                                valueName='companyId'
                                insertable={((auth.user.user?.data.roles.find(x => x == "Hızlı Firma Ekleme") && !selectedReceiverCustomer) || (auth.user.user?.data.roles.find(x => x == "Hızlı Firma Güncelleme") && selectedReceiverCustomer)) ? {
                                    onClick: () => {
                                        dispatch(storeFastFirm({
                                            companyId: selectedReceiverCustomer?.value,
                                            isReceiverFirm: true,
                                            onSubmit: async (response) => {
                                                onReceiverCustomerChange({ label: response.name, value: response.companyId })
                                            }
                                        }))
                                    }
                                } : undefined}
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Alıcı Firma Adres Türü"
                                isLabelRequired
                                selectedValue={selectedReceiverCustomerAddressType}
                                onChange={onReceiverCustomAddressTypeChange}
                                onMenuOpen={() => ConstantService.getConstantList('COMPANY_ADDRESS_TYPE')}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput
                                labelText="Alıcı Firma Adres"
                                isLabelRequired
                                value={receiverCustomerAddressText}
                                setValue={setReceiverCustomerAddressText}
                            />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText='Yükleme Firması'
                                isLabelRequired
                                selectedValue={selectedLoadingFirmCustomer}
                                onChange={onLoadingFirmCustomerChange}
                                onMenuOpen={[
                                    () => CompanyService.getCompanyList({ isSenderFirm: true, selectedMeetingCompanyType: { label: '', additionalValue1: MeetingCompanyTypeEnum.CALISILAN_MUSTERI } })
                                ]}
                                labelName='name'
                                valueName='companyId'
                                insertable={((auth.user.user?.data.roles.find(x => x == "Hızlı Firma Ekleme") && !selectedLoadingFirmCustomer) || (auth.user.user?.data.roles.find(x => x == "Hızlı Firma Güncelleme") && selectedLoadingFirmCustomer)) ? {
                                    onClick: () => {
                                        dispatch(storeFastFirm({
                                            companyId: selectedLoadingFirmCustomer?.value,
                                            isSenderFirm: true,
                                            onSubmit: async (response) => {
                                                onLoadingFirmCustomerChange({ label: response.name, value: response.companyId })
                                            }
                                        }))
                                    }
                                } : undefined}
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Yükleme Firması Adres Türü"
                                isLabelRequired
                                selectedValue={selectedLoadingFirmCustomerAddressType}
                                onChange={onLoadingFirmCustomAddressTypeChange}
                                onMenuOpen={() => ConstantService.getConstantList('COMPANY_ADDRESS_TYPE')}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput
                                labelText="Yükleme Firması Adres"
                                isLabelRequired
                                value={loadingFirmCustomerAddressText}
                                setValue={setLoadingFirmCustomerAddressText}
                            />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText='Teslim Firması'
                                isLabelRequired
                                selectedValue={selectedDeliverFirmCustomer}
                                onChange={onDeliverFirmCustomerChange}
                                onMenuOpen={[
                                    () => CompanyService.getCompanyList({ isReceiverFirm: true, selectedMeetingCompanyType: { label: '', additionalValue1: MeetingCompanyTypeEnum.CALISILAN_MUSTERI } })
                                ]}
                                labelName='name'
                                valueName='companyId'
                                insertable={((auth.user.user?.data.roles.find(x => x == "Hızlı Firma Ekleme") && !selectedDeliverFirmCustomer) || (auth.user.user?.data.roles.find(x => x == "Hızlı Firma Güncelleme") && selectedDeliverFirmCustomer)) ? {
                                    onClick: () => {
                                        dispatch(storeFastFirm({
                                            companyId: selectedDeliverFirmCustomer?.value,
                                            isReceiverFirm: true,
                                            onSubmit: async (response) => {
                                                onDeliverFirmCustomerChange({ label: response.name, value: response.companyId })
                                            }
                                        }))
                                    }
                                } : undefined}
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Teslim Firması Adres Türü"
                                isLabelRequired
                                selectedValue={selectedDeliverFirmCustomerAddressType}
                                onChange={onDeliverFirmCustomAddressTypeChange}
                                onMenuOpen={() => ConstantService.getConstantList('COMPANY_ADDRESS_TYPE')}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput
                                labelText="Teslim Firması Adres"
                                isLabelRequired
                                value={deliverFirmCustomerAddressText}
                                setValue={setDeliverFirmCustomerAddressText}
                            />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default FirmInformation;